import { intervalToDuration, formatDuration } from "date-fns";

export const getWorkExp = () => {
  const duration = intervalToDuration({
    start: new Date(2019, 9),
    end: new Date(),
  });

  return formatDuration(duration, { format: ["years"] });
};
